<template>
  <div class='container' @click="displayComplianceDetailsPopup">
    <div class="name-data-cell">
      {{ getDescription }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'DescriptionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async displayComplianceDetailsPopup() {
      this.$emit('showComplianceDetails', this.item);
    },
  },
  computed: {
    getDescription() {
      return this.item.description;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.container {
  display: flex;
  align-items: center;
  justify-content: left;
  cursor: pointer;
  height: 100vh;
  background-color: var(--bg-primary);
  .name-data-cell{
    color: var(--text-primary);
    font-size: rem(14);
    font-family: $font-family-regular;
    line-height: 1.2em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
    max-height: 2.6em;
  }
}
</style>
